import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SortDirection } from '@usf/ngrx-payment';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
})
export class TableHeaderComponent {
  @Input() dataColumns: {
    size: string;
    dataCyName: string;
    label?: string;
    sortField?: string;
    isCheckbox?: boolean;
    sortDirectionByDefault?: SortDirection;
    isNotSortable?: boolean;
    whiteSpaceWrap?: boolean;
  }[];
  @Input() sortField: string;
  @Input() sortDirection: SortDirection;
  @Input() isSelectable?: boolean;
  @Output() clickEmit: EventEmitter<{
    sortField: string;
    sortDirection: SortDirection;
  }> = new EventEmitter();

  readonly SortDirection = SortDirection;

  onClick(
    sortField: string,
    sortDirectionByDefault: SortDirection = SortDirection.DESC,
  ) {
    this.clickEmit.emit({ sortField, sortDirection: sortDirectionByDefault });
  }
}
